import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {OkCancelDialog} from '../../../../common/dialogs/okCancelDialog';
import {useWorkspacesEditor} from '../context/workspacesEditorContext';

/*
 * Component.
 */

export const DiscardWorkspacesChangesDialog: FC = () => {
  const {onDismissEditor, onDismissDialog} = useWorkspacesEditor();

  return (
    <OkCancelDialog
      okButtonLabel={<Trans id="discard-workspaces-changes-dialog-discard">Discard</Trans>}
      title={<Trans id="discard-workspaces-changes-dialog-title">Discard unsaved changes?</Trans>}
      onOkClick={onDismissEditor}
      onRequestClose={onDismissDialog}
    >
      <Trans id="discard-workspaces-changes-dialog-body">
        If you navigate away, your unsaved changes will be discarded.
      </Trans>
    </OkCancelDialog>
  );
};
